const apiUrl = process.env.REACT_APP_API_URL;

export const actionsSettings  = {
    backendRoutes:{
        obtenerCategorias:`${apiUrl}/categoria/obtener-todas`,
        obtenerCategoriasActivas:`${apiUrl}/categoria/obtener-activas`,
        obtenerCategoriaDetalle:`${apiUrl}/categoria/detalle-categoria`,
        crearCategoria:`${apiUrl}/categoria/crear-categoria`,
        actualizarCategoria:`${apiUrl}/categoria/editar-categoria`,
        productosPorCategoria:`${apiUrl}/categoria/productos-categoria`,

        

        obtenerProductos:`${apiUrl}/producto/obtener`,
        obtenerProductoDetalle:`${apiUrl}/producto/detalle`,
        obtenerInfoBasicaProducto:`${apiUrl}/producto/info_basica`,
        crearProducto:`${apiUrl}/producto/crear_producto`,
        editarProducto:`${apiUrl}/producto/editar_producto`,

        obtenerColoresProducto:`${apiUrl}/producto/obtener_colores_producto`,
        crearColorProducto:`${apiUrl}/producto/crear_color_producto`,
        editarColorProducto:`${apiUrl}/producto/editar_color_producto`,
        borrarColorProducto:`${apiUrl}/producto/borrar_color_producto`,
        obtenerTallasProducto:`${apiUrl}/producto/obtener_tallas`,
        

        obtenerImagenesColores:`${apiUrl}/producto/obtener_imagenes_colores`,
        subirImagen:`${apiUrl}/producto/cargar_imagen_producto`,
        borrarImagen:`${apiUrl}/producto/borrar_imagen_producto`,

        obtenerTallajes:`${apiUrl}/tallaje/obtener`,
        crearTallaje:`${apiUrl}/tallaje/crear-tallaje`,
        editarTallaje:`${apiUrl}/tallaje/editar-tallaje`,
        obtenerTallajeActivos:`${apiUrl}/tallaje/obtener-activas`,

        obtenerEntidades:`${apiUrl}/entidad/obtener`,
        crearEntidad:`${apiUrl}/entidad/crear`,
        obtenerInfoBasicaEntidad:`${apiUrl}/entidad/info_basica`,
        editarEntidad:`${apiUrl}/entidad/editar_entidad`,
        editarCargoEntidadProducto:`${apiUrl}/entidad/editar_cargo_bono`,
        cargarUsuariosEntidad:`${apiUrl}/entidad/cargar_usuarios`,
        obtenerUsuariosEntidad:`${apiUrl}/entidad/usuarios`,
        crearUsuarioEntidad:`${apiUrl}/entidad/crear_usuario_entidad`,
        actualizarUsuarioEntidad:`${apiUrl}/entidad/editar_usuario_entidad`,
        obtenerUsuarioCoordinador:`${apiUrl}/entidad/usuario_coordinador`,
        cargosEntidad:`${apiUrl}/entidad/cargos`,
        detalleCargoEntidad :`${apiUrl}/entidad/detalle_cargo`,
        detalleCargoBonoProducto :`${apiUrl}/entidad/detalle_cargo_bono_producto`,
        infoContrato :`${apiUrl}/entidad/info_contrato`,
        crearCargo:`${apiUrl}/entidad/crear_cargo`,
        editarCargo:`${apiUrl}/entidad/editar_cargo`,
        resumentProductosEntidad:`${apiUrl}/entidad/resumen_productos`,
        crearCargaBonoProducto:`${apiUrl}/entidad/crear_cargo_bono_producto`,
        obtenerCategoriasCrm:`${apiUrl}/entidad/obtener_categorias_crm`,
        obtenerSubCategoriasCrm:`${apiUrl}/entidad/obtener_subcategorias_crm`,
        obtenerProductosAsociadosCrm:`${apiUrl}/entidad/obtener_productos_asociados_crm`,
        asociarSubCategoriaBonosProducto:`${apiUrl}/entidad/asociar_subcategoria_bonos_producto`,
        editarAsociacionSubCategoriaBonosProducto:`${apiUrl}/entidad/editar_asociacion`,
        borrarAsociacionSubCategoriaBonosProducto:`${apiUrl}/entidad/borrar_asociacion`,

        consultarBonosFiltro:`${apiUrl}/entidad_bono/consultar_bonos`,
        consultarEntidadesEntregaBono:`${apiUrl}/entidad_bono/consultar_entidades`,
        consultarBonoProducto:`${apiUrl}/entidad_bono/consultar_bono_usuario`,
        redimirBonoEntrega:`${apiUrl}/entidad_bono/redimir_bono_entrega`,
        buscarBonosCedula:`${apiUrl}/entidad_bono/buscar_bonos_cedula`,
        obtenerBonosUsuarioRedencion:`${apiUrl}/entidad_bono/obtener_bonos_usuario_redencion`,
        redimirBonosTienda:`${apiUrl}/entidad_bono/redimir_bonos_tienda`,
        obtenerBonosRedimidosTienda:`${apiUrl}/entidad_bono/bonos_redimidos_tienda`,
        obtenerDetalleBonoRedimidosTienda:`${apiUrl}/entidad_bono/bonos_redimidos_detalle`,
        
        
        obtenerTemplateCargoBono:`${apiUrl}/entidad/obtener_template_cargo_bono`,
        guardarTemplateCargoBono:`${apiUrl}/entidad/guardar_template_cargo_bono`,
        generarBonosTemplateCargoBono:`${apiUrl}/entidad/generar_bonos_template`,
        
        
        reporteBonosEntregados:`${apiUrl}/orden_compra/reporte_bonos_entregados`,
        reporteBonosEntregadosTotal:`${apiUrl}/orden_compra/reporte_bonos_entregados_total`,
        
        validarOrdenUsuario:`${apiUrl}/orden_compra/validar_orden`,
        productosUsuario:`${apiUrl}/orden_compra/productos`,
        obtenerProductoDetalleCarro:`${apiUrl}/orden_compra/producto_detalle`,
        crearOrden:`${apiUrl}/orden_compra/crear`,
        obtenerUsuariosCoordinador:`${apiUrl}/orden_compra/usuarios_coordinador_entidad`,
        actualizarOrden:`${apiUrl}/orden_compra/actualizar`,

        obtenerSolicitudesPendientes:`${apiUrl}/solicitud_dotacion/ordenes_pendientes`,

        reporteGeneralEntidad:`${apiUrl}/reporte/reporte_general_entidad`,
        reporteComparativo:`${apiUrl}/reporte/reporte_comparativo`,
        bonosEntidad:`${apiUrl}/reporte/bonos_usuario`,

        usuariosAplicacion:`${apiUrl}/control_accesos/usuarios`,
        editarUsuarioAplicacion:`${apiUrl}/control_accesos/actualizar_usuario`,
        obtenerPerfilesAplicacion:`${apiUrl}/control_accesos/obtener_perfiles`,
        crearUsuarioAplicacion:`${apiUrl}/control_accesos/crear_usuario`,
        
        crearCategoriaCRM:`${apiUrl}/ecommerce/crear_categoria_crm`,
        editarCategoriaCRM:`${apiUrl}/ecommerce/editar_categoria_crm`,
        crearSubCategoriaCRM:`${apiUrl}/ecommerce/crear_sub_categoria_crm`,
        editarSubCategoriaCRM:`${apiUrl}/ecommerce/editar_sub_categoria_crm`,
        sincronizarCategoriaEcommerce:`${apiUrl}/ecommerce/sincronizar_categoria_ecommerce`,
        sincronizarSubCategoriaEcommerce:`${apiUrl}/ecommerce/sincronizar_subcategoria_ecommerce`,
        obtenerProductosCrm:`${apiUrl}/ecommerce/obtener_productos_crm`,
        descargarExcelImpresionProductosCrm:`${apiUrl}/ecommerce/descargar_excel_impresion_productos`,
        obtenerDetalleProductoCrm:`${apiUrl}/ecommerce/obtener_detalles_producto`,
        obtenerProductosListadoCrm:`${apiUrl}/ecommerce/obtener_productos_listado`,
        inactivarProductoCrm:`${apiUrl}/ecommerce/inactivar_producto`,
        activarProductoCrm:`${apiUrl}/ecommerce/reactivar_producto`,
        obtenerListadoPedidosEcommerce:`${apiUrl}/ecommerce/obtener_pedidos_ecommerce`,
        obtenerDetallePedidoEcommerce:`${apiUrl}/ecommerce/detalle_pedido_ecommerce`,
        crearSeguimientoPedidoEcommerce:`${apiUrl}/ecommerce/crear_seguimiento_pedido`,
        obtenerInventarioDisponiblePedidoEcommerce:`${apiUrl}/ecommerce/obtener_inventario_pedido`,
        obtenerInventarioEcommerce:`${apiUrl}/ecommerce/obtener_inventario_ecommerce`,
        obtenerDetalleInventarioEcommerce:`${apiUrl}/ecommerce/obtener_detalle_inventario_ecommerce`,
        sincronizarInventarioEcommerce:`${apiUrl}/ecommerce/sincronizar_inventario_ecommerce`,
        
        
        obtenerColoresProductoCrm:`${apiUrl}/ecommerce/obtener_colores_producto_crm`,
        crearColorProductoCrm:`${apiUrl}/ecommerce/crear_color_producto_crm`,
        actualizarColorProductoCrm:`${apiUrl}/ecommerce/editar_color_producto_crm`,
        obtenerImagenesColoresCrm:`${apiUrl}/ecommerce/obtener_imagenes_colores`,
        subirImagenCrm:`${apiUrl}/ecommerce/cargar_imagen_producto`,
        borrarImagenCrm:`${apiUrl}/ecommerce/borrar_imagen_producto`,
        obtenerTallasProductoCrm:`${apiUrl}/ecommerce/obtener_tallas`,
        obtenerTallajesCrm:`${apiUrl}/ecommerce/obtener_tallajes`,
        crearTallajeCrm:`${apiUrl}/ecommerce/crear-tallaje`,
        editarTallajecrm:`${apiUrl}/ecommerce/editar-tallaje`,
        obtenerTallajesActivosCrm:`${apiUrl}/ecommerce/obtener_tallajes_activas`,
        editarProductoCrm:`${apiUrl}/ecommerce/editar_producto`,
        crearProductoCrm:`${apiUrl}/ecommerce/crear_producto`,

        obtenerMediosPago:`${apiUrl}/pos/obtener_medios_pagos`,
        obtenerClientePorDocumento:`${apiUrl}/pos/obtener_cliente_por_documento`,
        obtenerTiendasPosUsuario:`${apiUrl}/pos/obtener_tiendas_pos_usuario`,
        obtenerVendedoresCrm:`${apiUrl}/pos/vendedores_crm`,
        obtenerVendedoresPorTiendaCrm:`${apiUrl}/pos/vendedores_por_tienda`,
        obtenerInfoProductoVenta:`${apiUrl}/pos/obtener_info_producto`,
        obtenerVentas:`${apiUrl}/pos/obtener_ventas_crm`,
        obtenerVentaDetalle:`${apiUrl}/pos/obtener_venta_detalle`,
        obtenerVentaARetomar:`${apiUrl}/pos/obtener_venta_retomar`,   
        crearVentaPos:`${apiUrl}/pos/crear_venta`,
        actualizarVentaPos:`${apiUrl}/pos/editar_venta`,
        cancelarVentaPos:`${apiUrl}/pos/cancelar_factura_pos`,
        obtenerImagenesProductoPos:`${apiUrl}/pos/imagenes_producto`,
    
        generarFacturaPdf:`${apiUrl}/pos/generar_factura_pdf`,
        obtenerClientesCrm:`${apiUrl}/pos/obtener_clientes`,
        actualizarClienteCrm:`${apiUrl}/pos/actualizar_cliente_crm`,
        crearClienteCrm:`${apiUrl}/pos/crear_cliente_crm`,
        obtenerTiposDocumento:`${apiUrl}/pos/obtener_tipos_documento`,
        obtenerVentasPendientesPos:`${apiUrl}/pos/obtener_ventas_pendientes_pos`,
        obtenerInventariosPos:`${apiUrl}/pos/obtener_inventario_pos`,
        buscarInventarioPorCodigo:`${apiUrl}/pos/busqueda_inventario_codigo`,
        obtenerProductoInventarioPorCodigoPos:`${apiUrl}/pos/inventario_codigo`,
        crearMovimientoInventario:`${apiUrl}/pos/entrada_salida_inventario`,
        transferirProductosEntreBodegas:`${apiUrl}/pos/transferir_producto_entre_bodegas`,
        obtenerHistorialTraslados:`${apiUrl}/pos/obtener_historial_translados`,
        obtenerMovimientosInventarios:`${apiUrl}/pos/obtener_movimiento_inventarios`,
        login:`${apiUrl}/users/authentication`,
    }
}